export enum LoanType {
    CREDIT_CARD_LOAN = 'CREDIT_CARD_LOAN',
    ACH_LOAN = 'ACH_LOAN',
    UNKNOWN = 'UNKNOWN'
}
